module.exports = __webpack_public_path__ + "img/compras.ba1d8546.png";